export const authFetch = (url, options = {}) => {
  return fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      "x-access-token": localStorage.getItem("jwtToken"),
    },
  });
};
